export const RECEIVE_APPS = 'RECEIVE_APPS'

export const START_LOADING = 'START_LOADING'

export const STOP_LOADING = 'STOP_LOADING'

export const CHANGE_ORDER_TYPE = 'CHANGE_ORDER_TYPE'
